import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage, withArtDirection, GatsbyImageProps } from "gatsby-plugin-image"

const imgQuery = graphql`
  {
    mob: file(relativePath: { eq: "BottomCta/Zadolzhennostej/treeMob.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, quality: 80)
      }
    }
    tab: file(relativePath: { eq: "BottomCta/Zadolzhennostej/treeTab.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, quality: 80)
      }
    }
    desk: file(relativePath: { eq: "BottomCta/Zadolzhennostej/treeDesk.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, quality: 80)
      }
    }
    large: file(relativePath: { eq: "BottomCta/Zadolzhennostej/treeLarge.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, quality: 80)
      }
    }
  }
`

export default function ChristmasTreeImg(props: Omit<GatsbyImageProps, "image">) {
  const data = useStaticQuery(imgQuery)
  const images = withArtDirection(getImage(data.large)!, [
    {
      media: "(max-width: 599.95px)",
      image: getImage(data.mob)!,
    },
    {
      media: "(max-width: 959.95px)",
      image: getImage(data.tab)!,
    },
    {
      media: "(max-width: 1279.95px)",
      image: getImage(data.desk)!,
    },
  ])

  return <GatsbyImage {...props} image={images} />
}
